import type { OutcomesApi } from "@/v2/api/metadata/outcomes";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatMultipleSupplementalNameFields } from "@/services/helpers";
import { buildOutcomeTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  outcomesApi: OutcomesApi;
}): TranslationsTab {
  const { ctx, outcomesApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildOutcomeTranslationFields,
    api: {
      get: async ({ values }) => {
        const outcome = values as { id: string | number };
        const translations = readApiData(await outcomesApi.getTranslations(outcome.id));
        const list = Array.isArray(translations) ? translations : [];
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );
        return { languages: ctx.read.languages(), translationsPerLanguage };
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id;
        const rows = (Array.isArray(model) ? model : []) as Record<string, unknown>[];
        await outcomesApi.update(entityId, {
          translations: rows.map((item) => ({
            name: item.name === "" ? null : item.name,
            info: item.info === "" ? null : item.info,
            languageCode: item.languageCode,
            eventMarketOutcomeName:
              item.eventMarketOutcomeName === "" ? null : item.eventMarketOutcomeName,
            supplementalNames: formatMultipleSupplementalNameFields(item),
          })),
        });
      },
    },
  };
}
